module.exports = __webpack_public_path__ + "static/media/capa.47722203.jpg";